export default {
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  apiURL: import.meta.env.VITE_ADFLOW_API_URL,
  routerBasePath: import.meta.env.VITE_PARCEL_ROUTER_BASE_PATH_TEMPLATES,
  VITE_CREATIVE_HUB_API_URL:
    (import.meta.env.VITE_CREATIVE_HUB_API_URL as string) ?? 'http://localhost:7777/graphql',
};
